module.exports = __webpack_public_path__ + "static/img/icon_facebook.5d6ea38a.png";